/* istanbul ignore file */
export default function computeDistanceBetween (from, to) {
    return window.google.maps.geometry.spherical.computeDistanceBetween(
        new window.google.maps.LatLng(from.latitude, from.longitude),
        new window.google.maps.LatLng(to.latitude, to.longitude)
    )
}
